export interface IConfig {
    authorityUri: string;
    baseUri: string;
    clientId: string;
    mapsApiKey: string;
    domain: string;
    googleAnalyticsKey: string;
}
